import React, { useState, useEffect } from 'react';
import AdminApi from './AdminApi';

const AdminRoleEditPage = ({ clickChangeMenu, editingRole }) => {
    const [formData, setFormData] = useState({
        rolename: '',
        order: 0,
        isDefault: false,
        manager: false,
        isxetduyet: false,
        isthay: false,
        isnoibo: false
    });
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (editingRole) {
            setFormData({
                rolename: editingRole.rolename || '',
                order: editingRole.order || 0,
                isDefault: editingRole.isDefault || false,
                manager: editingRole.manager || false,
                isxetduyet: editingRole.isxetduyet || false,
                isthay: editingRole.isthay || false,
                isnoibo: editingRole.isnoibo || false,
                roleid: editingRole.roleid
            });
        }
    }, [editingRole]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            // Ensure numeric types
            const payload = {
                ...formData,
                order: formData.order ? parseInt(formData.order) : 0
            };
            
            console.log("Saving role with payload:", payload);
            await AdminApi.saveRole(payload);
            alert(editingRole ? "Cập nhật thành công" : "Tạo nhóm thành công");
            clickChangeMenu('taikhoan-roles');
        } catch (err) {
            console.error("Error saving role:", err);
            const errorMsg = err.response?.data?.message || err.message || "Lỗi không xác định";
            alert(`Lỗi khi lưu nhóm thành viên: ${errorMsg}`);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="social-box" style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px', margin: '15px' }}>
            <h3 className="page-title" style={{ marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
                {editingRole ? 'Sửa Nhóm thành viên' : 'Tạo Nhóm thành viên'}
            </h3>
            
            <form onSubmit={handleSubmit} className="form-horizontal" style={{ marginTop: '30px' }}>
                <div className="control-group">
                    <label className="control-label" style={{ width: '200px' }}>Nhóm thành viên</label>
                    <div className="controls" style={{ marginLeft: '220px' }}>
                        <input type="text" name="rolename" value={formData.rolename} onChange={handleChange} className="span6" required />
                    </div>
                </div>

                <div className="control-group" style={{ marginTop: '15px' }}>
                    <label className="control-label" style={{ width: '200px' }}>Thứ tự</label>
                    <div className="controls" style={{ marginLeft: '220px' }}>
                        <input type="number" name="order" value={formData.order} onChange={handleChange} className="span6" />
                    </div>
                </div>

                <div className="control-group" style={{ marginTop: '15px' }}>
                    <label className="control-label" style={{ width: '200px' }}>Mặc định (cho tài khoản đăng ký mới)</label>
                    <div className="controls" style={{ marginLeft: '220px' }}>
                        <input type="checkbox" name="isDefault" checked={formData.isDefault} onChange={handleChange} />
                    </div>
                </div>

                <div className="control-group" style={{ marginTop: '15px' }}>
                    <label className="control-label" style={{ width: '200px' }}>Quản lý</label>
                    <div className="controls" style={{ marginLeft: '220px' }}>
                        <input type="checkbox" name="manager" checked={formData.manager} onChange={handleChange} />
                    </div>
                </div>

                <div className="control-group" style={{ marginTop: '15px' }}>
                    <label className="control-label" style={{ width: '200px' }}>Người duyệt ?</label>
                    <div className="controls" style={{ marginLeft: '220px' }}>
                        <input type="checkbox" name="isxetduyet" checked={formData.isxetduyet} onChange={handleChange} />
                    </div>
                </div>

                <div className="control-group" style={{ marginTop: '15px' }}>
                    <label className="control-label" style={{ width: '200px' }}>Trụ trì ?</label>
                    <div className="controls" style={{ marginLeft: '220px' }}>
                        <input type="checkbox" name="isthay" checked={formData.isthay} onChange={handleChange} />
                    </div>
                </div>

                <div className="control-group" style={{ marginTop: '15px' }}>
                    <label className="control-label" style={{ width: '200px' }}>Nội bộ ?</label>
                    <div className="controls" style={{ marginLeft: '220px' }}>
                        <input type="checkbox" name="isnoibo" checked={formData.isnoibo} onChange={handleChange} />
                    </div>
                </div>

                <div className="form-actions" style={{ backgroundColor: '#f9f9f9', borderTop: '1px solid #eee', padding: '15px 220px', marginTop: '30px', marginLeft: '-20px', marginRight: '-20px', borderRadius: '0 0 8px 8px' }}>
                    <button type="submit" className="btn btn-primary" style={{ backgroundColor: '#5cb85c', border: 'none', padding: '6px 20px' }} disabled={isLoading}>
                        {isLoading ? 'Đang xử lý...' : (editingRole ? 'Lưu' : 'Tạo')}
                    </button>
                    <button type="button" className="btn" style={{ marginLeft: '10px', padding: '6px 20px' }} onClick={() => clickChangeMenu('taikhoan-roles')}>Quay lại</button>
                </div>
            </form>
        </div>
    );
};

export default AdminRoleEditPage;
